import { render, staticRenderFns } from "./UiChart.vue?vue&type=template&id=60677c48&"
import script from "./UiChart.vue?vue&type=script&lang=js&"
export * from "./UiChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports